import { useRequiredContext } from "@redotech/react-util/context";
import { marketingHomeDashboardFlag } from "@redotech/redo-marketing-common/feature-flags";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";

/** The BFCM prep page, under the Marketing base URL. */
export const MARKETING_BFCM_PREP_PATH = "bfcm-prep";

export function useMarketingBfcmPrepEnabled(): boolean {
  const team = useRequiredContext(TeamContext);
  return team.featureFlags?.[marketingHomeDashboardFlag.key] === true;
}
